// extracted by mini-css-extract-plugin
export var infoRow = "_pt-2";
export var labelContainer = "_pt-0";
export var rightInfo = "_pt-1";